import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { where } from "firebase/firestore";
import { Coverage } from "risa-data-model";
import { FirestoreService } from "../../../../shared/api/firebase/firestoreService";
import { FirestoreCollectionReference } from "../../../../shared/api/firebase/references";
import { DataState } from "../../store/store";

const initialPatientResponsibilityArrayCountState: DataState<number> = {
  loading: false,
  error: null,
  data: null,
};

const patientResponsibilityArrayCountSlice = createSlice({
  name: "PatientResponsibilityArrayCountSlice",
  initialState: initialPatientResponsibilityArrayCountState,
  reducers: {
    setPatientResponsibilityArrayCount(
      state: DataState<number>,
      action: PayloadAction<number>,
    ) {
      state.data = action.payload;
      state.error = null;
      state.loading = false;
    },
    setError(state: DataState<number>, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    setLoading(state: DataState<number>, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    resetPatientResponsibilityArrayCount(state: DataState<number>) {
      state.data = null;
      state.error = null;
      state.loading = false;
    },
  },
});

export const {
  setPatientResponsibilityArrayCount,
  setError,
  setLoading,
  resetPatientResponsibilityArrayCount,
} = patientResponsibilityArrayCountSlice.actions;

export const getPatientResponsibilityArrayCount =
  (orderId: string) => async (dispatch: any) => {
    const data = FirestoreService.listenToQueryCollection<Coverage>(
      FirestoreCollectionReference.coverage(orderId),
      (documents) => {
        let totalCount = 0;
        if (documents.length === 0) {
          dispatch(setPatientResponsibilityArrayCount(0));
        } else {
          const patientResponsibilities =
            documents[documents.length - 1].PatientResponsibilities;
          if (
            patientResponsibilities &&
            patientResponsibilities instanceof Map
          ) {
            totalCount = patientResponsibilities.size;
          } else if (
            patientResponsibilities &&
            typeof patientResponsibilities === "object"
          ) {
            totalCount = Object.keys(patientResponsibilities).length;
          }
          dispatch(setPatientResponsibilityArrayCount(totalCount));
        }
      },
      (error: any) => {
        dispatch(setError(error.message));
      },
      where("IsEligible", "==", true),
    );
    return data;
  };

export default patientResponsibilityArrayCountSlice.reducer;
